<div class="page-root">
  <div class="title">
    <mat-icon>error</mat-icon>
  </div>

  <div class="title">
    <div class="typo-h1">{{ data.title }}</div>
  </div>

  <div class="body">
    <div class="body-text">
      {{ data.message }}
    </div>
  </div>

  <div class="actions">
    <app-text-button mat-dialog-close [text]="'button.understood' | transloco" colorVariant="primary" trailingIcon="check_circle"></app-text-button>
  </div>
</div>
